// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.message {
    padding: 8px;
    margin-bottom: 20px;
    border-radius: 5px;
    text-align: left;
    display: flex;
    align-items: center;
    width: fit-content;
}

.message span{
    font-size: 0.9rem;
}

.message.error {
    background-color: #db0012;
    color: #ffffff;
    border: 1px solid #e40017;
}

.message.warning {
    background-color: #fff3cd;
    color: #856404;
    border: 1px solid #ffeeba;
}

.message.info {
    background-color: #d1ecf1;
    color: #000000;
    border: 1px solid #bee5eb;
}

.message.success {
    background-color: #00a500;
    color: #ffffff;
    border: 1px solid #06ac00;
}

.close-button {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    padding: 0;
    margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/message/Message.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB","sourcesContent":["\n.message {\n    padding: 8px;\n    margin-bottom: 20px;\n    border-radius: 5px;\n    text-align: left;\n    display: flex;\n    align-items: center;\n    width: fit-content;\n}\n\n.message span{\n    font-size: 0.9rem;\n}\n\n.message.error {\n    background-color: #db0012;\n    color: #ffffff;\n    border: 1px solid #e40017;\n}\n\n.message.warning {\n    background-color: #fff3cd;\n    color: #856404;\n    border: 1px solid #ffeeba;\n}\n\n.message.info {\n    background-color: #d1ecf1;\n    color: #000000;\n    border: 1px solid #bee5eb;\n}\n\n.message.success {\n    background-color: #00a500;\n    color: #ffffff;\n    border: 1px solid #06ac00;\n}\n\n.close-button {\n    background: none;\n    border: none;\n    color: inherit;\n    cursor: pointer;\n    padding: 0;\n    margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
